import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { makeRESTApiRequests } from "../helpers/api";
import Loader from "./Loader";

const getLocalResponse = (endpoint) => {
  try {
    const localChoices = localStorage.getItem(endpoint);
    return localChoices ? JSON.parse(localChoices) : null;
  } catch {
    return null;
  }
};

const CachedResponse = ({ render, listEndpoint, restrictedRoutes = [] }) => {
  const { pathname } = useLocation();
  const [response, setResponse] = useState(() =>
    getLocalResponse(listEndpoint)
  );
  const [responseLoading, setResponseLoading] = useState(
    () => !getLocalResponse(listEndpoint)
  );

  const fetchRemoteResponse = async () => {
    const { response: remote, error } = await makeRESTApiRequests({
      endpoint: `/${listEndpoint}/list`,
    });

    if (error) {
      toast.error(error);
      setResponseLoading(false);
      return;
    }

    setResponse(remote);
    setResponseLoading(false);
    localStorage.setItem(listEndpoint, JSON.stringify(remote));
  };

  useEffect(() => {
    if (restrictedRoutes.includes(pathname)) {
      setResponse((prev) => prev ?? getLocalResponse(listEndpoint) ?? []);
      setResponseLoading(false);
      return;
    }

    // Already have data — refresh quietly, no loader flash
    if (response) {
      fetchRemoteResponse();
      return;
    }

    const localResponse = getLocalResponse(listEndpoint);
    if (localResponse) {
      setResponse(localResponse);
      setResponseLoading(false);
      fetchRemoteResponse();
      return;
    }

    setResponseLoading(true);
    fetchRemoteResponse();
  }, [pathname]);

  if (responseLoading) return <Loader />;

  return response ? render(response) : null;
};

export default CachedResponse;
